import { render } from "./ReadReportComponent.vue?vue&type=template&id=167bce29&scoped=true"
import script from "./ReadReportComponent.vue?vue&type=script&lang=js"
export * from "./ReadReportComponent.vue?vue&type=script&lang=js"

import "./ReadReportComponent.vue?vue&type=style&index=0&id=167bce29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167bce29"]])

export default __exports__